import React from 'react';
import { Route, Redirect, RouteProps } from 'react-router-dom';
import { connect } from 'react-redux';
import { AppState } from '../root.reducer';
import { isAuthenticatedSelector, isAuthenticationLoadingSelector } from './authentication.selectors';
import { FullPageLoadingComponent } from '../FullpageLoading.component';

interface PrivateRouteStateProps {
    isAuthenticationLoading: boolean;
    isAuthenticated: boolean;
}

const PrivateRouteComponent: React.FC<PrivateRouteStateProps & RouteProps> = ({ isAuthenticated, isAuthenticationLoading, ...rest }) => {
    if (isAuthenticationLoading) {
        return <FullPageLoadingComponent />;
    }

    if (isAuthenticated) {
        return (<Route {...rest} />);
    }

    const url = `/login?returnUrl=${rest.location?.pathname}`;
    return (
        <Redirect to={url} />
    );
};

const mapStateToProps = (state: AppState): PrivateRouteStateProps => ({
    isAuthenticationLoading: isAuthenticationLoadingSelector(state),
    isAuthenticated: isAuthenticatedSelector(state)
});

export default connect<PrivateRouteStateProps, {}, RouteProps, AppState>(
    mapStateToProps
)(PrivateRouteComponent);